<template>
  <b-modal
    ref="modal"
    hide-footer
    no-close-on-backdrop
    header-bg-variant="danger"
  >
    <template #modal-title>
      <span>
        {{ labels.unauthorizedModal.title }}
      </span>
    </template>
    <p class="txt-20">
      {{ labels.unauthorizedModal.message }}
    </p>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.page.reports.engagement
    },
  },
  methods: {
    show() {
      this.$refs.modal.show()
    },
    hide() {
      this.$refs.modal.hide()
    },
  },
}
</script>

<style scoped lang="scss"></style>
